import gql from 'graphql-tag'

export const CONTACT_DELETE_MUTATION = gql`
    mutation contactDelete(
        $id: ID!
    ) {
        contactDelete(
            id: $id
        ) {
            status
        }
    }
`
